import React, { Component } from 'react';
import moment from 'moment-timezone';

import API from 'API';

import Calendar from 'components/common/Calendar';
import Loader from 'components/common/Loader';

moment.tz.setDefault('Europe/London');

//-------------------------------------------------------------------------------------------------------------------

class SelectDateAndTime extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isLoadingDate: true,
            month: null,
            errorMessage: null
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const { bookingRequest } = this.props;
        let month = moment.utc();
        
        // If bookingRequest.date is selected already, show that month instead
        if (bookingRequest.date) {
            month = moment.utc(bookingRequest.date);
            this.loadDate();
        }

        // Load one month at a time until we find a month with availability
        month = month.startOf('month');
        let dates = [];
        for (var i = 0; i < 12; i++) {
            dates = await this.loadMonth(month.toDate());
            if (dates.length > 0) {
                break;
            }
            month.add(1, 'month').startOf('day');
        }
        this.setState({
            isLoading: false,
            dates
        });
        if (dates.length == 0) {
            this.setState({
                errorMessage: 'Sorry, there is no availability over the next 12 months. Please call us instead.'
            });
        }
    }

    async loadMonth(month) {
        return new Promise(async (resolve) => {
            this.setState({
                month,
                isLoading: true
            });
            let dates = await API.call('book/list-dates', {
                ...this.props.bookingRequest,
                startDate: month
            });
            dates = dates.map(d => new Date(d));
            this.setState({
                dates,
            }, () => {
                resolve(dates);
            });
        });
    }

    async loadDate() {
        this.setState({ isLoadingDate: true });
        const { timeSlots, duration } = await API.call('book/list-time-slots', {
            ...this.props.bookingRequest
        });
        this.setState({
            timeSlots,
            duration,
            isLoadingDate: false
        }, () => {
            this.scrollToAvailableTimesHeader();
        });
    }

    selectTimeSlot(timeSlot) {
        this.props.onChange({
            timeSlot
        }, () => {
            setTimeout(() => {
                this.props.onNextClicked();
            }, 250);
        });
    }

    render() {
        const { isBusy, errorMessage } = this.state;
        const { onBackClicked, onNextClicked, bookingRequest } = this.props;
        
        if (errorMessage) {
            return (
                <div className="alert alert-danger">
                    {errorMessage}
                </div>
            );
        }

        return (<>

            <h2>Select Date &amp; Time</h2>

            <p className="subtitle">
                Please select a date from the calendar below.
            </p>
            <p className="subtitle">
                Dates highlighted in <span className="highlight-yellow">yellow</span> are available.
            </p>

            {this.renderCalendar()}

            {this.renderSelectedDate()}

            <div className="nav-buttons">

                <button type="button" className="btn btn-secondary me-auto" onClick={() => onBackClicked()} disabled={isBusy}>
                    Back
                </button>

                <button type="button" className="btn ms-auto" onClick={() => onNextClicked()} disabled={!bookingRequest.date || !bookingRequest.timeSlot}>
                    Next
                </button>

            </div>

        </>);
    }

    scrollToAvailableTimesHeader() {
        setTimeout(() => {
            const element = document.querySelector('.available-times-header');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 0);
    }

    renderCalendar() {
        const { isLoading, isBusy, errorMessage, month, dates } = this.state;
        const { accountInfo, bookingRequest, onChange } = this.props;

        if (isLoading || isBusy) {
            return (
                <Loader />
            );
        }
        return (
            <Calendar
                month={month}
                selectedDate={bookingRequest.date}
                dates={dates}
                maxMonthsLookAhead={accountInfo.maxMonthsLookAhead}
                onChangeMonth={async (month) => {
                    await this.loadMonth(month);
                    this.setState({ isLoading: false });
                }}
                onSelect={(date) => {
                    this.setState({ isLoadingDate: true });
                    onChange({
                        date,
                        timeSlot: null
                    }, () => this.loadDate());
                }}
            />
        );
    }

    renderSelectedDate() {
        const { isLoadingDate, timeSlots, isBusy, duration } = this.state;
        const { bookingRequest } = this.props;
        if (!bookingRequest.date) {
            return null;
        }
        
        return (<>

            <hr />

            <h2 className="available-times-header">
                {moment(bookingRequest.date).format('dddd Do MMM YYYY')}
            </h2>

            {isLoadingDate ?
                <Loader /> :
                <div>

                    {timeSlots.length > 0 ?
                        <>
                            <p className="subtitle">
                                When would you like the sweep to arrive?
                            </p>
                            <p className="subtitle">
                                (Appointments are typically around {duration} minutes long)
                            </p>
                        </> :
                        <p className="subtitle">
                            Sorry, turns out we don't have availability on this day after all.<br />
                            Please try a different date or call us to discuss.
                        </p>
                    }

                    <div className="btn-stack time-slots">

                        {timeSlots.map(ts => {
                            const isSelected = (ts == bookingRequest.timeSlot);
                            return (
                                <button
                                    key={ts}
                                    type="button"
                                    className={`btn btn-secondary time-slot-btn ${isSelected ? 'selected' : ''}`}
                                    onClick={() => this.selectTimeSlot(ts)}
                                    disabled={isBusy}
                                >
                                    {ts}
                                </button>
                            );
                        })}

                    </div>

                </div>
            }

        </>);
    }
}

export default SelectDateAndTime;